<template>
  <div class="LKMunMehFormsList">
    <div class="LKMunMehFormsList__progress">
      <LKMunMehCardProgress
        :mun-meh-id="munMehId"
      />
    </div>

    <ComponentFilter
      ref="filters"
      @change="onChangeDebounced"
    />

    <BTableCommon
      type="munmeh-expert-forms"
      :list="list"
      :pagination="pagination"
      :loading="isLoading"
      fixed-header

      @change:pagination="onChangePagination"
      @action:edit="onGoToReview"
      @action:view="onGoToView"
    />
  </div>
</template>

<script>
import BTableCommon from '@/components/tables/BTableCommon.vue'
import ComponentFilter from '@/views/LKMunMeh/components/ExpertFormsListModal/LKMunMehExpertsFormsListFilter.vue'
import { DEFAULT_PER_PAGE } from '@/helpers/enums/params'
import { cloneDeep } from 'lodash'
import { LkMunMehAdapter } from '@/views/LKMunMeh/store/LkMunMehAdapter'
import LKMunMehCardProgress from '@/views/LKMunMeh/components/LKMunMehCard/LKMunMehCardProgress.vue'
import { lkMapper } from '@/store/modules/lk'
import { LK_MUN_MEH_FORM_REVIEW_ROUTES } from '@/views/LKMunMeh/Review/utils'
import { LK_MUN_MEH_FORM_REVIEW_SECOND_ROUTES } from '@/views/LKMunMeh/ReviewSecond/utils'
import { VIEW } from '@/helpers/enums/view-types'

const DEFAULT_PARAMS = {
  page: 1,
  per_page: DEFAULT_PER_PAGE,
  count: 0,
}

export default {
  name: 'LKMunMehFormsList',
  components: { LKMunMehCardProgress, BTableCommon, ComponentFilter },
  props: {
    munMehId: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    list: [],
    pagination: { ...DEFAULT_PARAMS },
  }),
  computed: lkMapper.mapGetters(['profile']),
  methods: {
    asyncData() {
      const params = { ...this.pagination }
      this.onGetData(params)
    },
    async onGoToReview(v) {
      const name = v.level_2 ? LK_MUN_MEH_FORM_REVIEW_SECOND_ROUTES.FORM : LK_MUN_MEH_FORM_REVIEW_ROUTES.FORM
      // const { id } = this.profile
      // if (v.second_level_expert_id === id) {
      //   // Второй уровень
      //   name = LK_MUN_MEH_FORM_REVIEW_SECOND_ROUTES.FORM
      // } else if ([v.first_level_expert_one_id, v.first_level_expert_two_id].includes(id)) {
      //   name = LK_MUN_MEH_FORM_REVIEW_ROUTES.FORM
      // }
      //
      // if (!name) {
      //   this.$notice.warning('Текущий пользователь не является экспертом для данной формы')
      //   return
      // }

      const { topic_slug, slug } = this.$route.params

      this.$emit('close')

      await this.$router.push({
        name,
        params: {
          munMehId: this.munMehId,
          formId: v.id,
          slug,
          topic_slug,
        },
      })
    },
    async onGoToView(v) {
      const name = LK_MUN_MEH_FORM_REVIEW_ROUTES.FORM
      const { topic_slug, slug } = this.$route.params

      this.$emit('close')

      await this.$router.push({
        name,
        params: {
          munMehId: this.munMehId,
          formId: v.id,
          slug,
          topic_slug,
          viewType: VIEW,
        },
      })
    },
    onChangePagination(options) {
      const { filters, ate_filter } = this.prepareFilterData(this.$refs.filters.form)
      const params = {
        ...this.pagination,
        ...filters,
        ate_filter,
        ...options,
      }

      this.pagination.page = options.page || DEFAULT_PARAMS.page
      this.pagination.per_page = options.per_page || DEFAULT_PARAMS.per_page

      return this.onGetData(params)
    },
    async onGetData(params) {
      this.isLoading = true
      const adapter = new LkMunMehAdapter()

      try {
        const result = await adapter.api.getExpertsForms(this.munMehId, params)
        this.list = result.data
        this.pagination.count = result.meta.count
      } catch (e) {
        this.$notice.errors(e)
      }
      this.isLoading = false
    },
    async onChangeDebounced(options) {
      const { filters, ate_filter } = this.prepareFilterData(options)
      const params = {
        ...filters,
        ate_filter,
        ...this.pagination,
        page: 1,
      }

      await this.onGetData(params)
    },
    prepareFilterData(options) {
      const filters = cloneDeep(options)
      const ate_filter = filters.region?.id || filters.municipality?.id || filters.school?.id
      delete filters.region
      delete filters.municipality
      delete filters.school
      return { filters, ate_filter }
    },
  },
}
</script>

<style lang="scss">
.LKMunMehFormsList {
  margin: 16px;

  &__progress {
    padding: 16px;
    background-color: $webflow-color-blue-shadow;
  }
}
</style>
